export enum LifecycleState {
  DATA_LOADED = 'DATA_LOADED',
}
